import { PurchaseRepository } from 'application/repositories/PurchaseRepository';
import {
    PurchaseCompanyPayload,
    PurchaseCompanyPayloadStep2,
    PurchaseCompanyResultEntity,
} from 'domain/entities/PurchaseCompanyEntity';
import {
    FamilyPayload,
    PurchasePayload,
    PurchaseResulttEntity,
    PurchaseStep3Payload,
    RegistMemberIndivPayload,
} from 'domain/entities/PurchaseEntity';

export class PurchaseUseCase implements PurchaseUseCaseInterface {
    private purchaseRepo: PurchaseRepository;
    constructor(purchaseRepo: PurchaseRepository) {
        this.purchaseRepo = purchaseRepo;
    }

    async getDefaultInfo(payload: { offerId?: number }): Promise<PurchaseResulttEntity> {
        return await this.purchaseRepo.getDefaultInfo(payload);
    }

    async getDefaultInfoStep2(payload: { offerId?: number }): Promise<PurchaseResulttEntity> {
        return await this.purchaseRepo.getDefaultInfoStep2(payload);
    }

    async getDefaultInfoStep3(payload: {
        listed_property_id?: number;
        purchasePrice?: number;
        purchaseOfferId?: number;
        procedureId?: number;
        loanUseStatus?: number;
    }): Promise<PurchaseResulttEntity> {
        return await this.purchaseRepo.getDefaultInfoStep3(payload);
    }
    async savePurchaseIndividualStep1(payload: PurchasePayload): Promise<any> {
        return await this.purchaseRepo.savePurchaseIndividualStep1(payload);
    }
    async savePurchaseIndividualStep2(payload: FamilyPayload): Promise<any> {
        return await this.purchaseRepo.savePurchaseIndividualStep2(payload);
    }
    async savePurchaseIndividualStep3(payload: PurchaseStep3Payload): Promise<any> {
        return await this.purchaseRepo.savePurchaseIndividualStep3(payload);
    }

    async registerMemberIndiv(payload: RegistMemberIndivPayload): Promise<any> {
        return await this.purchaseRepo.registerMemberIndiv(payload);
    }
    async getDefaultInfoCompany(payload: {
        offerId?: number;
    }): Promise<PurchaseCompanyResultEntity> {
        return await this.purchaseRepo.getDefaultInfoCompany(payload);
    }
    async getDefaultInfoCompanyStep2(payload: {
        listedPropertyId?: number;
        purchasePrice?: number;
        offerId?: number;
    }): Promise<PurchaseCompanyResultEntity> {
        return await this.purchaseRepo.getDefaultInfoCompanyStep2(payload);
    }
    async savePurchaseCompanyStep1(payload: PurchaseCompanyPayload): Promise<any> {
        return await this.purchaseRepo.savePurchaseCompanyStep1(payload);
    }
    async savePurchaseCompanyStep2(payload: PurchaseCompanyPayloadStep2): Promise<any> {
        return await this.purchaseRepo.savePurchaseCompanyStep2(payload);
    }
    async registerMemberCompany(payload: RegistMemberIndivPayload): Promise<any> {
        return await this.purchaseRepo.registerMemberCompany(payload);
    }
}

export interface PurchaseUseCaseInterface {
    getDefaultInfo(payload: { offerId?: number }): Promise<PurchaseResulttEntity>;
    getDefaultInfoStep2(payload: { offerId?: number }): Promise<PurchaseResulttEntity>;
    getDefaultInfoStep3(payload: {
        listed_property_id?: number;
        purchasePrice?: number;
        purchaseOfferId?: number;
        procedureId?: number;
        loanUseStatus?: number;
    }): Promise<PurchaseResulttEntity>;
    savePurchaseIndividualStep1(payload: PurchasePayload): Promise<any>;
    savePurchaseIndividualStep2(payload: FamilyPayload): Promise<any>;
    savePurchaseIndividualStep3(payload: PurchaseStep3Payload): Promise<any>;
    registerMemberIndiv(payload: RegistMemberIndivPayload): Promise<any>;
    getDefaultInfoCompany(payload: { offerId?: number }): Promise<PurchaseCompanyResultEntity>;
    getDefaultInfoCompanyStep2(payload: {
        listedPropertyId?: number;
        purchasePrice?: number;
        offerId?: number;
    }): Promise<PurchaseCompanyResultEntity>;
    savePurchaseCompanyStep1(payload: PurchaseCompanyPayload): Promise<any>;
    savePurchaseCompanyStep2(payload: PurchaseCompanyPayloadStep2): Promise<any>;
    registerMemberCompany(payload: RegistMemberIndivPayload): Promise<any>;
}
